import { CommunicationService } from './../common/communication.service';
import { DashboardEventService } from './../dashboard/dashboard-event.service';
import { LocalDBService } from './../service/local-db.service';
import { MarketDataService } from './../market-data/market-data.service';
import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular';
import { AppConfig } from './../app.config';
import { SurvivalHorizonService } from './../survival-horizon/survival-horizon.service';
import { Subscription } from 'rxjs';
import { ConstantValue } from './../common/constant-value';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ComponentFactoryResolver, Input } from '@angular/core';
import {

    WebApiEndpoints,
    GetSecurityPositionDetailRequest,
    GetSecurityPositionDetailOutput,
    GetSurvivalHorizonServiceDataOutput,

    SecurityPositionDetail,

    GetQuotesRequest,


    SecurityBufferType,
    SecurityBufferAllocation,
} from '@liquitics/transaction';

import {
    SpecialCollateralType,
    SecuritySectorDisplays,
    SecurityStabilityTypeDisplays,
    CountryCodeDisplays,
    Ratings,
    BondTypeDisplays,
    SecurityCountryCodeDisplays,
} from '@liquitics/transaction';
import {
    buildISINQuote,
    buildISINHCQuote,
    Quote,
    QuoteTypes,
    buildConventionalFXQuote,
    QuoteTenor,
} from '@liquitics/transaction';
import {
    CurrencyUtil,
} from '@liquitics/transaction';
import {
    UserProfileSingleCurrency,
} from '@liquitics/transaction';
import { AwsUtil } from '../authentication/aws.service';
import * as moment from 'moment';
import { PIE_COLOR_STRIP_1, PIE_COLOR_STRIP_2, PIE_COLOR_STRIP_3, PIE_COLOR_STRIP_4, PIE_COLOR_STRIP_5 } from '../common/color-util';
import { createSimplePieChart } from '../common/chart/graphical-chart-generator';
import { viewPortHeightToPX } from '../common/render-util';
import { SnapshotService } from '../snapshot/snapshot.service';

const ALLOCATIONS_KEY = 'LocalDBBufferAllocations';

@Component({
    selector: 'app-buffer',
    templateUrl: './buffer.component.html',
    styleUrls: ['./buffer.component.scss']
})
export class BufferComponent implements OnInit, AfterViewInit, OnDestroy {
    currencies: string[];
    selectedCurrency: string;
    ladderInitialized = false;
    ladderRows: { date: string, position: number }[] = [];

    selectedBufferType: SecurityBufferType;

    operationalGapCylinderChart: any;
    operationalGapAmount = 0;
    operationalFilledGapAmount = 0;
    operationalSummary: string;

    regulatoryGapCylinderChart: any;
    regulatoryGapAmount = 15.0;
    regulatoryFilledGapAmount = 0;
    regulatorySummary;

    loading = false;
    tableData: any[];
    allColumns: any[];
    selectedColumns: any[];
    allFrozenColumns: any[];
    frozenColumns: any[];
    frozenSecurities: SecurityPositionDetailRow[] = [];

    specialCollateralTypes: ConstantValue[];
    bondTypes: ConstantValue[];
    countries: ConstantValue[];
    sectors: ConstantValue[];
    ratings: ConstantValue[];
    stabilityTypes: ConstantValue[];

    selectedSpecialCollateralTypes: ConstantValue[];
    selectedBondTypes: ConstantValue[];
    selectedCountries: ConstantValue[];
    selectedSectors: ConstantValue[];
    selectedRatings: ConstantValue[];
    selectedStabilityTypes: ConstantValue[];
    nextCorporateActionStartDate: Date;
    nextCorporateActionEndDate: Date;
    bondYieldRangeValues: number[];

    showSelected: boolean;
    showPositionsForWeek: boolean;
    showAllocations: boolean;
    securityDisplayMode: 'DEFAULT_SECURITY_ATTRIBUTES' | 'EXTENDED_SECURITY_ATTRIBUTES' | 'SEVEN_DAY';

    broker1: string;
    broker2: string;
    broker3: string;

    typeChart: any;
    sectorChart: any;
    countryChart: any;
    ratingChart: any;
    maturityChart: any;
    vpHeightToPx = viewPortHeightToPX;

    private dataStreamDisposable: Subscription;
    subscription: Subscription;
    batchIdentifier: string;

    constructor(private appConfig: AppConfig,
        private awsUtil: AwsUtil,
        private dashboardEventService: DashboardEventService,
        private survivalHorizonService: SurvivalHorizonService,
        private marketDataService: MarketDataService,
        private amChartsService: AmChartsService,
        private communicationService: CommunicationService,
        private snapshotService: SnapshotService,
        private localDB: LocalDBService) {
        const profile = appConfig.activeUserProfile as UserProfileSingleCurrency;
        this.broker1 = profile.broker1;
        this.broker2 = profile.broker2;
        this.broker3 = profile.broker3;
    }

    ngOnInit() {
        this.allColumns = [
            // tslint:disable:max-line-length
            { field: 'currency', header: 'Currency', type: 'string', width: '4em', displayModes: ['DEFAULT_SECURITY_ATTRIBUTES', 'EXTENDED_SECURITY_ATTRIBUTES', 'SEVEN_DAY'] },
            { field: 'position0d', header: 'Today', type: 'position', width: '5em', displayModes: ['DEFAULT_SECURITY_ATTRIBUTES', 'EXTENDED_SECURITY_ATTRIBUTES', 'SEVEN_DAY'] },
            { field: 'position1d', header: '1D', type: 'position', width: '5em', hideWhen: 'weekPositions', displayModes: ['SEVEN_DAY'] },
            { field: 'position2d', header: '2D', type: 'position', width: '5em', hideWhen: 'weekPositions', displayModes: ['SEVEN_DAY'] },
            { field: 'position3d', header: '3D', type: 'position', width: '5em', hideWhen: 'weekPositions', displayModes: ['SEVEN_DAY'] },
            { field: 'position4d', header: '4D', type: 'position', width: '5em', hideWhen: 'weekPositions', displayModes: ['SEVEN_DAY'] },
            { field: 'position5d', header: '5D', type: 'position', width: '5em', hideWhen: 'weekPositions', displayModes: ['SEVEN_DAY'] },
            { field: 'position6d', header: '6D', type: 'position', width: '5em', hideWhen: 'weekPositions', displayModes: ['SEVEN_DAY'] },
            { field: 'price', header: 'Price', type: 'price', width: '5em', displayModes: ['DEFAULT_SECURITY_ATTRIBUTES', 'EXTENDED_SECURITY_ATTRIBUTES', 'SEVEN_DAY'] },
            { field: 'repoValue1', header: this.broker1, type: 'value', width: '5em', displayModes: ['DEFAULT_SECURITY_ATTRIBUTES', 'EXTENDED_SECURITY_ATTRIBUTES', 'SEVEN_DAY'] },
            { field: 'repoValue2', header: this.broker2, type: 'value', width: '5em', displayModes: ['DEFAULT_SECURITY_ATTRIBUTES', 'EXTENDED_SECURITY_ATTRIBUTES', 'SEVEN_DAY'] },
            { field: 'repoValue3', header: this.broker3, type: 'value', width: '5em', displayModes: ['DEFAULT_SECURITY_ATTRIBUTES', 'EXTENDED_SECURITY_ATTRIBUTES', 'SEVEN_DAY'] },
            { field: 'sector', header: 'Sector', type: 'string', width: '5em', displayModes: ['DEFAULT_SECURITY_ATTRIBUTES', 'EXTENDED_SECURITY_ATTRIBUTES'] },
            { field: 'rating', header: 'Rating', type: 'string', width: '5em', displayModes: ['DEFAULT_SECURITY_ATTRIBUTES'] },
            { field: 'countryDisplay', header: 'Country', type: 'string', width: '10em', displayModes: ['DEFAULT_SECURITY_ATTRIBUTES', 'EXTENDED_SECURITY_ATTRIBUTES'] },
            { field: 'remainingMaturityTenor', header: 'Remaining Maturity', type: 'string', width: '10em', displayModes: ['DEFAULT_SECURITY_ATTRIBUTES'] },
            { field: 'nextCouponDate', header: 'Next Coupon', type: 'string', width: '8em', displayModes: ['DEFAULT_SECURITY_ATTRIBUTES'] },
            { field: 'specialCollateralType', header: 'Special Collateral', type: 'string', width: '10em', displayModes: ['EXTENDED_SECURITY_ATTRIBUTES'] },
            { field: 'nextCorporateActionDate', header: 'Next CA', type: 'string', width: '8em', displayModes: ['EXTENDED_SECURITY_ATTRIBUTES'] },
            { field: 'bondType', header: 'Type', type: 'string', width: '5em', displayModes: ['EXTENDED_SECURITY_ATTRIBUTES'] },
            { field: 'bondYield', header: 'Yield', type: 'price', width: '5em', displayModes: ['EXTENDED_SECURITY_ATTRIBUTES'] },
            { field: 'stabilityType', header: 'Stability', type: 'string', width: '6em', displayModes: ['DEFAULT_SECURITY_ATTRIBUTES'] },
            // { field: 'lastRegulatoryBufferAmount', header: 'Regulatory', type: 'value', width: '8em' },
            // { field: 'lastOperationalBufferAmount', header: 'Operational', type: 'value', width: '8em' },
        ];
        this.allFrozenColumns = [
            { field: 'checked', header: '', type: 'check', width: '2.25em' },
            { field: 'saved', header: '', type: 'saved', width: '2.25em' },
            { field: 'isin', header: 'ISIN', type: 'string' },
            { field: 'operationalBufferAmount', header: 'Oper.', type: 'number', width: '5em', hideWhen: 'OPERATIONAL', editable: true },
            { field: 'regulatoryBufferAmount', header: 'Reg.', type: 'number', width: '5em', hideWhen: 'REGULATORY', editable: true },
            { field: 'allocatableAmount', header: 'Available', type: 'position', width: '5em' },
        ];
        this.specialCollateralTypes = ConstantValue.fromArray([SpecialCollateralType.GC, SpecialCollateralType.SC]);
        this.bondTypes = ConstantValue.fromEnumDisplayMap(BondTypeDisplays);
        this.countries = ConstantValue.fromEnumDisplayMap(SecurityCountryCodeDisplays);
        this.sectors = ConstantValue.fromEnumDisplayMap(SecuritySectorDisplays);
        this.ratings = ConstantValue.fromArray(Ratings);
        this.stabilityTypes = ConstantValue.fromEnumDisplayMap(SecurityStabilityTypeDisplays);
        this.selectedBufferType = 'OPERATIONAL';
        this.securityDisplayMode = 'DEFAULT_SECURITY_ATTRIBUTES';
        this.selectedColumns = [];
        this.showSelected = true;
        this.showAllocations = true;
        this.updateColumns();
        this.updateFrozenColumns();
        this.currencies = this.appConfig.activeUserProfile.getCurrencies();
        this.selectedCurrency = this.currencies[0];
        this.computeGap();
        // this.computeAndSetBufferFlows();
        this.createBreakdownCharts();
        // this.operationalGapCylinderChart = this.createCylinderChart('operationalcylinderdiv');
        // this.regulatoryGapCylinderChart = this.createCylinderChart('regulatorycylinderdiv');
        this.batchIdentifier = this.snapshotService.applicationConfiguration.batchIdentifiers
            .filter((modeBatchIdentifier: string) => {
                return modeBatchIdentifier.startsWith('ALM') && modeBatchIdentifier.endsWith('EOD');
            })
            .map((modeBatchIdentifier: string) => {
                return modeBatchIdentifier.split('=')[1];
            })[0];
    }


    ngAfterViewInit() {
        this.dataStreamDisposable = this.survivalHorizonService.getPollingDataSubject()
            .subscribe({
                next: (data: GetSurvivalHorizonServiceDataOutput) => {
                    // this.refreshLadder(data);
                    this.computeGap();
                    this.updateBreakdownCharts();
                }, error: (err) => {
                    console.log(err);
                    throw err;
                }
            });
        this.subscription = this.dashboardEventService.survivalHorizonModeSubject.subscribe({
            next: mode => {
                if (mode === 'buffer') {
                    this.loadAllocations();
                }
            }
        });
        this.ladderInitialized = true;
    }

    // refreshLadder(data: GetSurvivalHorizonServiceDataOutput) {
    //     if (this.ladderInitialized && data && data.positions) {
    //         this.ladderRows = data
    //             .positions
    //             .filter((position) => {
    //                 return position.currency === this.selectedCurrency;
    //             })
    //             .slice(0, 5)
    //             .map((position) => {
    //                 if (position.netAmount < this.operationalGapAmount) {
    //                     this.operationalGapAmount = position.netAmount;
    //                 }
    //                 return {
    //                     date: position.bucket.slice(5),
    //                     position: position.netAmount,
    //                 };
    //             })
    //     }
    //     this.ladderInitialized = true;
    // }

    search() {
        const request = new GetSecurityPositionDetailRequest();
        if (this.selectedSpecialCollateralTypes) {
            request.specialCollateralType = this.selectedSpecialCollateralTypes.map((selected) => selected.objectValue);
        }
        if (this.selectedBondTypes) {
            request.bondType = this.selectedBondTypes.map((selected) => selected.objectValue);
        }
        if (this.selectedCountries) {
            request.country = this.selectedCountries.map((selected) => selected.objectValue);
        }
        if (this.selectedSectors) {
            request.sector = this.selectedSectors.map((selected) => selected.objectValue);
        }
        if (this.selectedRatings) {
            request.rating = this.selectedRatings.map((selected) => selected.objectValue);
        }
        if (this.selectedStabilityTypes) {
            request.stabilityType = this.selectedStabilityTypes.map((selected) => selected.objectValue);
        }
        if (this.nextCorporateActionStartDate) {
            if (!request.nextCorporateActionDateRange) {
                request.nextCorporateActionDateRange = [];
            }
            request.nextCorporateActionDateRange[0] = moment(this.nextCorporateActionStartDate).format('YYYY-MM-DD');
        }
        if (this.nextCorporateActionEndDate) {
            if (!request.nextCorporateActionDateRange) {
                request.nextCorporateActionDateRange = [];
            }
            request.nextCorporateActionDateRange[1] = moment(this.nextCorporateActionEndDate).format('YYYY-MM-DD');
        }
        // if (this.bondYieldRangeValues) {

        // }

        request.date = this.appConfig.getTodayString();
        this.processRequest(request);
    }

    loadAllocations(): Promise<any> {
        const request = new GetSecurityPositionDetailRequest();
        request.date = this.appConfig.getTodayString();
        request.allocatedOnly = true;
        return this.processRequest(request)
            .then(() => {
                this.computeGap();
            });
    }

    processRequest(request: GetSecurityPositionDetailRequest): Promise<any> {
        let positionRows: SecurityPositionDetailRow[];
        const newFrozenRows: SecurityPositionDetailRow[] = [];
        const fxRates = new Map<string, number>();
        this.loading = true;
        return this.awsUtil.webAPICall(WebApiEndpoints.QuerySecurityPositionDetails, request)
            .then((output: GetSecurityPositionDetailOutput) => {
                const isins = [];
                const positionDetails = output.positionDetails
                    .map((position: SecurityPositionDetail) => {
                        position['max'] = position.position0d;
                        isins.push(position.isin);
                        return position;
                    })
                positionRows = positionDetails as SecurityPositionDetailRow[];
                return isins;
            })
            .then((isins: string[]) => {
                const quoteNames = [];
                isins.forEach((isin: string) => {
                    quoteNames.push(buildISINQuote(isin, request.date, 'DISPLAY').name);
                    quoteNames.push(buildISINQuote(isin, request.date, 'UNIT').name);
                    if (this.broker1) {
                        quoteNames.push(buildISINHCQuote(isin, request.date, this.broker1).name);
                    }
                    if (this.broker2) {
                        quoteNames.push(buildISINHCQuote(isin, request.date, this.broker2).name);
                    }
                    if (this.broker3) {
                        quoteNames.push(buildISINHCQuote(isin, request.date, this.broker3).name);
                    }
                });

                const currencies = positionRows
                    .filter((position: SecurityPositionDetailRow) => {
                        return position.currency !== this.selectedCurrency;
                    })
                    .map((position: SecurityPositionDetailRow) => {
                        return position.currency;
                    });
                const uniqueCurrencies = Array.from(new Set<string>(currencies));
                uniqueCurrencies.forEach((currency: string) => {
                    let fxRate = this.marketDataService.getSingleRate(
                        buildConventionalFXQuote(currency, this.selectedCurrency, QuoteTenor.SPOT, request.date).name);
                    if (!CurrencyUtil.isFXQuoteConvention(currency, this.selectedCurrency)) {
                        fxRate = 1 / fxRate;
                    }
                    fxRates.set(currency, fxRate);
                })
                fxRates.set(this.selectedCurrency, 1.0);
                const isinQuoteRequest = new GetQuotesRequest();
                isinQuoteRequest.quoteNames = quoteNames;
                isinQuoteRequest.batchIdentifier = this.batchIdentifier;

                return this.marketDataService.fetchQuotes(isinQuoteRequest);
            })
            .then((quotes: Quote[]) => {
                positionRows = positionRows
                    .filter((position: SecurityPositionDetailRow, index: number, self: SecurityPositionDetailRow[]) => {
                        // Dedupe
                        const foundIndex = self.findIndex((f: SecurityPositionDetailRow) => {
                            return f.isin === position.isin;
                        });
                        return foundIndex === index;
                    })
                    ;
                positionRows = positionRows
                    .map((position: SecurityPositionDetailRow) => {
                        const isinDisplayQuote = quotes.find((quote: Quote) => {
                            return quote.name.startsWith(`${QuoteTypes.ISIN}.${position.isin}.`) && quote.name.endsWith('DISPLAY');
                        });
                        if (isinDisplayQuote) {
                            position.price = isinDisplayQuote.rate;
                        }
                        const isinUnitQuote = quotes.find((quote: Quote) => {
                            return quote.name.startsWith(`${QuoteTypes.ISIN}.${position.isin}.`) && quote.name.endsWith('UNIT');
                        });
                        if (isinUnitQuote) {
                            position.unitPrice = isinUnitQuote.rate;
                        }
                        const hc1Quote = quotes.find((quote: Quote) => {
                            return quote.name.startsWith(`${QuoteTypes.ISINHC}.${position.isin}.`) && quote.name.endsWith((this.broker1));
                        });
                        const hc2Quote = quotes.find((quote: Quote) => {
                            return quote.name.startsWith(`${QuoteTypes.ISINHC}.${position.isin}.`) && quote.name.endsWith((this.broker2));
                        });
                        const hc3Quote = quotes.find((quote: Quote) => {
                            return quote.name.startsWith(`${QuoteTypes.ISINHC}.${position.isin}.`) && quote.name.endsWith((this.broker3));
                        });
                        const fxRate = fxRates.get(position.currency);
                        if (hc1Quote) {
                            position.repoValue1 = position.position0d * position.unitPrice * fxRate * ((100 - hc1Quote.rate) / 100);
                        }
                        if (hc2Quote) {
                            position.repoValue2 = position.position0d * position.unitPrice * fxRate * ((100 - hc2Quote.rate) / 100);
                        }
                        if (hc3Quote) {
                            position.repoValue3 = position.position0d * position.unitPrice * fxRate * ((100 - hc3Quote.rate) / 100);
                        }
                        const foundFrozen = this.frozenSecurities.find((frozen: SecurityPositionDetailRow) => {
                            return frozen.isin === position.isin;
                        });
                        if (foundFrozen) {
                            position.checked = true;
                            position.saved = true;
                            newFrozenRows.push(position);
                        }
                        if (position.operationalBufferAmount > 0 || position.regulatoryBufferAmount > 0) {
                            position.checked = true;
                            position.saved = true;
                            if (!foundFrozen) {
                                newFrozenRows.push(position);
                            }
                        }
                        position.countryDisplay = CountryCodeDisplays.get(position.country);
                        return position;
                    })
                    .sort((a: SecurityPositionDetailRow, b: SecurityPositionDetailRow) => {
                        // let aBuff;
                        // let bBuff;
                        // if (this.selectedBufferType === 'OPERATIONAL') {
                        //     aBuff = a.operationalAllocationValue;
                        //     bBuff = b.operationalAllocationValue;
                        // } else {
                        //     aBuff = a.regulatoryAllocationValue;
                        //     bBuff = b.regulatoryAllocationValue;
                        // }
                        // if (aBuff === bBuff) {
                        return b.position0d - a.position0d;
                        // } else {
                        //     return aBuff - bBuff;
                        // }
                    })
                    ;
            })
            .then(() => {
                this.tableData = positionRows;
                this.frozenSecurities = newFrozenRows;
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
            })
    }

    ngOnDestroy() {
        if (this.dataStreamDisposable) {
            this.dataStreamDisposable.unsubscribe();
        }
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    updateColumns() {
        this.selectedColumns = [];
        this.selectedColumns.push(
            ...this.allColumns
                .filter((col) => {
                    if (col.displayModes) {
                        return (col.displayModes.includes(this.securityDisplayMode));
                    }
                    return true;
                })
        );
    }

    updateFrozenColumns() {
        this.frozenColumns = [];
        this.frozenColumns.push(
            ...this.allFrozenColumns
                .filter((col) => {
                    if (col.hideWhen) {
                        if (this.showAllocations) {
                            if (col.hideWhen === this.selectedBufferType) {
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            return false;
                        }
                    }
                    return true;
                })
        );
    }


    onShowPositionForWeekChange(event) {
        this.updateColumns();
    }

    onShowAllocationsChange(event) {
        this.updateFrozenColumns();
    }

    onRowSelect(event) {
        // this.frozenSecurities.push(event.data);
        event.data.checked = true;
        this.computeGap();
    }

    onRowUnselect(event) {
        // this.frozenSecurities = this.frozenSecurities
        //     .filter((row) => {
        //         return row.isin !== event.data.isin;
        //     });
        event.data.checked = false;
        this.computeGap();
    }

    setSelectedBufferType(type: 'OPERATIONAL' | 'REGULATORY') {
        if (type !== this.selectedBufferType) {
            this.selectedBufferType = type;
            this.updateBreakdownCharts();
            this.updateFrozenColumns();
        }
    }

    computeGap() {
        this.operationalFilledGapAmount = this.frozenSecurities.reduce((sum, position: SecurityPositionDetailRow) => {
            if (position.operationalBufferAmount) {
                const bestTotalValue = Math.max(position.repoValue1, position.repoValue2, position.repoValue3);
                const allocatedPercentage = position.operationalBufferAmount / position.position0d;
                position.operationalAllocationValue = bestTotalValue * allocatedPercentage;
                sum += position.operationalAllocationValue;
            }
            return sum;
        }, 0);
        this.regulatoryFilledGapAmount = this.frozenSecurities.reduce((sum, position: SecurityPositionDetailRow) => {
            if (position.regulatoryBufferAmount) {
                const bestTotalValue = Math.max(position.repoValue1, position.repoValue2, position.repoValue3);
                const allocatedPercentage = position.regulatoryBufferAmount / position.position0d;
                position.regulatoryAllocationValue = bestTotalValue * allocatedPercentage;
                sum += position.regulatoryAllocationValue;
            }
            return sum;
        }, 0);
        const scale = CurrencyUtil.currencyScalePower(this.selectedCurrency);
        const opGap = Math.abs(this.operationalGapAmount);
        const opFilled = Math.abs(this.operationalFilledGapAmount / scale);
        const opPercent = ((opFilled / opGap) * 100).toFixed(0);
        this.operationalSummary = `Gap: ${opGap.toFixed(1)} | Filled: ${opFilled.toFixed(1)} (${opPercent}%)`;

        const regGap = Math.abs(this.regulatoryGapAmount);
        const regFilled = Math.abs(this.regulatoryFilledGapAmount / scale);
        const regPercent = ((regFilled / regGap) * 100).toFixed(0);
        this.regulatorySummary = `Gap: ${regGap.toFixed(1)} | Filled: ${regFilled.toFixed(1)} (${regPercent}%)`;

        this.frozenSecurities
            .forEach((position: SecurityPositionDetailRow) => {
                this.computeAllocatableAmount(position);
            });
    }

    saveBufferAllocations() {
        const allocations = [];
        this.frozenSecurities
            .forEach((position: SecurityPositionDetailRow) => {
                // position.persisted = true;
                // return position;
                const regAllocation = new SecurityBufferAllocation();
                regAllocation.allocationDate = this.appConfig.getTodayString();
                regAllocation.quantity = position.regulatoryBufferAmount;
                regAllocation.value = position.regulatoryAllocationValue;
                regAllocation.currency = this.selectedCurrency;
                regAllocation.identifier = position.isin;
                regAllocation.type = 'REGULATORY';
                regAllocation.username = this.awsUtil.cognitoUtil.getCurrentUser().getUsername();
                const operAllocation = new SecurityBufferAllocation();
                operAllocation.allocationDate = this.appConfig.getTodayString();
                operAllocation.quantity = position.operationalBufferAmount;
                operAllocation.value = position.operationalAllocationValue;
                operAllocation.currency = this.selectedCurrency;
                operAllocation.identifier = position.isin;
                operAllocation.type = 'OPERATIONAL';
                operAllocation.username = this.awsUtil.cognitoUtil.getCurrentUser().getUsername();
                allocations.push(operAllocation);
            });
        // this.localDB.setItem(ALLOCATIONS_KEY, JSON.stringify(allocations));
        Promise.all(
            allocations.map((allocation: SecurityBufferAllocation) => {
                return this.awsUtil.webAPICall(WebApiEndpoints.SaveSecurityBufferAllocation, allocation, true);
            })
        ).then(() => {
            this.survivalHorizonService.setBufferFlows([]);
            this.communicationService.openSnackBar('Buffer allocation saved.', 'Ok', 3000);
        });
    }

    // computeAndSetBufferFlows() {
    //     const bufferFlows = [];
    //     const operationDate = this.appConfig.getTodayString();
    //     this.frozenSecurities
    //         .forEach((position: SecurityPositionDetailRow) => {
    //             const todayFlow = new SurvivalHorizonData()
    //             todayFlow.currency = this.selectedCurrency;
    //             todayFlow.bucket = operationDate;
    //             todayFlow.bufferAmount = position.operationalAllocationValue;
    //             bufferFlows.push(todayFlow);
    //             // const maturityFlow = new SurvivalHorizonData()
    //             // todayFlow.currency = this.selectedCurrency;
    //             // todayFlow.bucket = position.;
    //             // todayFlow.bufferAmount = - position.operationalAllocationValue;
    //         });
    //     this.survivalHorizonService.setBufferFlows(bufferFlows);
    // }

    updateFundingGapChart() {
        this.operationalGapCylinderChart.dataProvider = [{
            'category': this.operationalGapAmount,
            'filledGap': Math.abs(this.operationalFilledGapAmount),
            'gap': Math.abs(this.operationalGapAmount)
        }];
        this.operationalGapCylinderChart.validateData();
        this.operationalGapCylinderChart.invalidateSize();

        this.regulatoryGapCylinderChart.dataProvider = [{
            'category': this.regulatoryGapAmount,
            'filledGap': Math.abs(this.regulatoryFilledGapAmount),
            'gap': Math.abs(this.regulatoryGapAmount)
        }];
        this.regulatoryGapCylinderChart.validateData();
        this.regulatoryGapCylinderChart.invalidateSize();
    }

    createGroupedPieRows(groupingField: string, valueField: string): any[] {
        const rows = [];
        const groupedByGrouping = this.frozenSecurities
            .reduce((grouped, position: SecurityPositionDetailRow) => {
                const key = position[groupingField];
                grouped[key] = grouped[key] || [];
                grouped[key].push(position);
                return grouped;
            }, {});
        return Object.keys(groupedByGrouping)
            .map((key: string) => {
                const positions = groupedByGrouping[key];
                const positionSum = positions.reduce((sum, position: SecurityPositionDetailRow) => {
                    sum += position[valueField] || 0;
                    return sum;
                }, 0);
                return { key: key, value: positionSum };
            })
    }


    createBreakdownCharts() {
        this.typeChart = createSimplePieChart(this.amChartsService, 'typechartdiv', 'key', 'value', PIE_COLOR_STRIP_1);
        this.sectorChart = createSimplePieChart(this.amChartsService, 'sectorchartdiv', 'key', 'value', PIE_COLOR_STRIP_2);
        this.countryChart = createSimplePieChart(this.amChartsService, 'countrychartdiv', 'key', 'value', PIE_COLOR_STRIP_3);
        this.ratingChart = createSimplePieChart(this.amChartsService, 'ratingchartdiv', 'key', 'value', PIE_COLOR_STRIP_4);
        this.maturityChart = createSimplePieChart(this.amChartsService, 'maturitychartdiv', 'key', 'value', PIE_COLOR_STRIP_5);
    }

    updateBreakdownCharts() {
        const valueField = this.selectedBufferType === 'OPERATIONAL' ? 'operationalAllocationValue' : 'regulatoryAllocationValue';
        this.typeChart.dataProvider = this.createGroupedPieRows('bondType', valueField);
        this.typeChart.validateData();
        this.typeChart.invalidateSize();
        this.sectorChart.dataProvider = this.createGroupedPieRows('sector', valueField);
        this.sectorChart.validateData();
        this.sectorChart.invalidateSize();
        this.countryChart.dataProvider = this.createGroupedPieRows('countryDisplay', valueField);
        this.countryChart.validateData();
        this.countryChart.invalidateSize();
        this.ratingChart.dataProvider = this.createGroupedPieRows('rating', valueField);
        this.ratingChart.validateData();
        this.ratingChart.invalidateSize();
        this.maturityChart.dataProvider = this.createGroupedPieRows('remainingMaturityTenor', valueField);
        this.maturityChart.validateData();
        this.maturityChart.invalidateSize();
    }

    createCylinderChart(div: string): any {
        return this.amChartsService.makeChart(div, {
            'hideCredits': true,
            'theme': 'light',
            'type': 'serial',
            'depth3D': 100,
            'angle': 30,
            'autoMargins': false,
            'marginLeft': 0,
            'marginRight': 0,
            'marginTop': 0,
            'marginBottom': 0,
            'valueAxes': [{
                'stackType': 'regular',
                'gridAlpha': 0
            }],
            'graphs': [{
                'type': 'column',
                'topRadius': 1,
                'columnWidth': 1,
                'showOnAxis': false,
                'lineThickness': 2,
                'lineAlpha': 0.5,
                'lineColor': '#FFFFFF',
                'fillColors': '#8d003b',
                'fillAlphas': 0.8,
                'valueField': 'filledGap'
            }, {
                'type': 'column',
                'topRadius': 1,
                'columnWidth': 1,
                'showOnAxis': false,
                'lineThickness': 2,
                'lineAlpha': 0.5,
                'lineColor': '#cdcdcd',
                'fillColors': '#cdcdcd',
                'fillAlphas': 0.5,
                'valueField': 'gap'
            }],

            'categoryField': 'category',
            'categoryAxis': {
                'axisAlpha': 0,
                'labelOffset': 0,
                'gridAlpha': 0
            }
        });
    }




    onAllocationChange(row: SecurityPositionDetailRow) {
        this.computeAllocatableAmount(row);
    }
    computeAllocatableAmount(row: SecurityPositionDetailRow) {
        row.allocatableAmount = (row.position0d || 0) - (row.operationalBufferAmount || 0) - (row.regulatoryBufferAmount || 0);
    }
}

class SecurityPositionDetailRow extends SecurityPositionDetail {
    checked: boolean;
    saved: boolean;
    persisted: boolean;
    price: number;
    unitPrice: number;
    repoValue1: number;
    repoValue2: number;
    repoValue3: number;
    regulatoryAllocationValue: number;
    operationalAllocationValue: number;
    allocatableAmount: number;
    countryDisplay: string;
}

